import React, { Component } from "react";
// import { Redirect } from 'react-router-dom';
import axios from "axios";
// import { Form, Radio, Input } from "antd";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import S3 from "react-aws-s3";
import Compressor from "compressorjs";
// import moment from "moment";
import BackAndBreadCrmOneParent from "./BackAndBreadCumOneParent";
import LoaderRounded from "./LoaderRounded";
import { connect } from "react-redux";
import { uploadImageFromBackend } from "../Utils/uploadImage";

class AddnewForum extends Component {
  constructor(props) {
    super(props);
    const first_name = localStorage.getItem("first_name");
    const last_name = localStorage.getItem("last_name");
    this.state = {
      name: "",
      college_code: localStorage.getItem("collegeCode"),
      CollegeData: [],
      diaplay_name: "",
      forum_full_description: "",
      forum_images: [],
      forum_type: "",
      is_published: "",
      MemberData: [],
      memberlist: "",
      member: "",
      redirect: false,
      forum_created_by: `${first_name} ${last_name}`,
      errors: {},
      arr: [],
      loader: false,
      districtsLocal: this.props.UserData.districts,
      subCityName: this.props.UserData.sub_city_name
        ? this.props.UserData.sub_city_name
        : "",
    };
    this.uploadImageToS3 = this.uploadImageToS3.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFormChange = this.handleFormChange.bind(this);
    this.selectMember = this.selectMember.bind(this);

    // Create the ref object
    this.nameInputRef = React.createRef();
  }

  handleFormChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  addNewImage(newImage) {
    let img_arr = this.state.forum_images;
    img_arr.push(newImage);
    this.setState({
      forum_images: img_arr,
    });
  }

  removeImageURL(id) {
    let img_arr = this.state.forum_images;
    img_arr = img_arr.filter((img) => img.id !== id);
    this.setState({
      forum_images: img_arr,
    });
  }

  // for upload image
  uploadImageToS3(event) {
    const image = event.target.files[0];
    if (!image) return;

    if (image.type === "image/png" || image.type === "image/jpeg") {
      new Compressor(image, {
        quality: 0.6,
        success: async (compressedResult) => {
          try {
            let newFileName = image.name.replace(/\..+$/, "");
            let fileType = image.type;

            // Use the uploadImageFromBackend utility
            const imageURL = await uploadImageFromBackend(newFileName, fileType, compressedResult);

            if (imageURL) {
              this.addNewImage({
                type: "IMAGE",
                url: imageURL,
                name: newFileName,
                id: Math.floor(Math.random() * 9999999999),
              });
            } else {
              console.error("Image upload failed.");
            }
          } catch (error) {
            console.error("Error uploading image:", error);
          }
        },
        error: (err) => {
          console.error("Compression error:", err.message);
        },
      });
    } else {
      console.error("Invalid file type. Please upload a PNG or JPEG image.");
    }
  }


  handleFormValidation = () => {
    const {
      name,
      college_code,
      //no need of validation on following
      college_name,
      forum_full_description,
      forum_created_by,
      forum_type,
      is_published,
      forum_images,
      diaplay_name,
    } = this.state;
    let errors = {};
    let formIsValid = true;
    let arr = [];

    // Empty forum name
    if (!name) {
      errors["name"] = "Give Your Answer.";
      formIsValid = false;
      arr.push({ field: "Forum Name", message: "Forum Name" });
    } else if (!name.match(/^[a-zA-Z ]*$/)) {
      formIsValid = false;
      errors["name"] = "Please enter alphabet characters only.";
      arr.push({ field: "Forum Name", message: "Forum Name" });
    }
    // if (!diaplay_name) {
    //   formIsValid = false;
    //   errors["diaplay_name"] = "Give Your Answer.";
    //   arr.push({ field: "diaplay_name", message: "diaplay_name" });
    // }
    // Empty college_name
    if (!college_name) {
      formIsValid = false;
      errors["college_name"] = "Give Your Answer.";
      arr.push({ field: "college_name", message: "college_name" });
    }

    // Empty description
    // if (!forum_full_description) {
    //   formIsValid = false;
    //   errors["forum_full_description"] = "Give Your Answer.";
    //   arr.push({
    //     field: "forum_full_description",
    //     message: "forum_full_description",
    //   });
    // }

    // Empty forum_type
    // if (!forum_type) {
    //   formIsValid = false;
    //   errors["forum_type"] = "Give Your Answer.";
    //   arr.push({ field: "forum_type", message: "forum_type" });
    // }

    // Empty is_published
    if (!is_published) {
      formIsValid = false;
      errors["is_published"] = "Give Your Answer.";
      arr.push({ field: "is_published", message: "Is Published" });
    }

    //Empty created by
    // if (!forum_created_by) {
    //   formIsValid = false;
    //   errors["forum_created_by"] = "Give Your Answer.";
    //   arr.push({ field: "forum_created_by", message: "forum_created_by" });
    // }

    // Empty forum_images
    // if (forum_images.length <= 0) {
    //   formIsValid = false;
    //   errors["forum_images"] = "Give Your Answer.";
    //   arr.push({ field: "forum_images", message: "forum_images" });
    // }

    this.setState({
      errors: errors,
    });

    // Focus on the first input field with an error message
    if (arr.length > 0) {
      const firstErrorField = document.getElementById(`${arr[0].field}`);
      if (firstErrorField && firstErrorField.focus) {
        firstErrorField.focus();
        //alert(arr[0].message); // Display error message
      }
    }

    return formIsValid;
  };

  UNSAFE_componentWillMount() {
    console.log(this.props.Selected_collgege);
    this.getMember();
    this.getCollege();
  }

  getMember() {
    // let Id = this.state.IssueId.issue_id

    axios
      .get(
        process.env.REACT_APP_TALK_API +
        "/forum/get/forum/member-details/FORUM_COL0001234_BOYS"
      )
      .then((response) => {
        this.setState({
          MemberData: response.data,
        });
      })
      .catch((error) => {
        console.log("Error", error);
      });
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    if (this.handleFormValidation()) {
      const Forum = {
        ...this.state,
      };

      let statesSet = this;

      await axios
        .post(process.env.REACT_APP_TALK_API + "/forum/create", Forum)
        .then((res) => {
          if (res.status === 200) {
            this.props.history.push("/forumlist");
            alert("Forum Added successfully");
            statesSet.setState({
              changeToView: true,
              redirect: true,
              loader: true,
            });
          }
        })
        .then((err) => {
          console.log("err", err);
        });
    } else {
      // Focus on the first input field with an error
      // if (this.nameInputRef.current) {
      //   this.nameInputRef.current.focus();
      // }
    }
  };
  selectMember = (e) => {
    let memberlist = e.target.value;
    this.setState({
      member: memberlist,
    });
  };

  getCollege() {
    let districts = this.props.UserData.districts;

    // console.log("event fired text",e.target.value);
    axios
      .post(process.env.REACT_APP_APIURL + `/coordinator/college/all/city`, {
        districts,
      })
      .then((response) => {
        localStorage.getItem("collegecode", response.data.college_code);
        this.setState({
          CollegeData: response.data,
        });
      })
      .catch((error) => {
        console.log("Error", error);
      });
  }
  render() {
    return (
      <>
        <Sidebar />
        <div className="main">
          <div className="topbar">
            <Navbar />
          </div>
          {/* <div>
                    <select type="button" className="mx-2 btn btn-secondary btn-md dropdown-toggle" onChange={this.selectMember} id="Member" style={{ float: "right", width: "120px",marginTop:"10px" }}>
                                    <option value={null}> --Member-- </option>
                                    {this.state.MemberData.map((e, key) => {
                                        return <option key={key} value={e.first_name.toString() + e.last_name.toString()}>{e.first_name.toString() + e.last_name.toString()}  </option>;
                                    })}
                                </select>

                    </div> */}
          <div className="container">
            <BackAndBreadCrmOneParent
              backLink={
                this.props.location.data ? "/collegeList" : "/ForumList"
              }
              backName={this.props.location.data ? "CollegeList" : "ForumList"}
              currentTabName="Add Forum"
            />
            <div className="row mt-4">
              <div
                style={{
                  heigh: "800vh",
                  overflow: "hidden",
                }}
                className="col-lg-8 col-md-8 col-12 paddingAll10 mx-auto "
              >
                <div className="card rounded shadow shadow-sm ">
                  <div className="card-header">
                    <h3 className="mb-0 center">Add Forum</h3>
                  </div>
                  <div className="card-body">
                    <form
                      id="candidate"
                      method="post"
                      onSubmit={this.handleSubmit}
                      encType="multipart/form-data"
                    >
                      <div className="form-group">
                        <label htmlFor="Forum Name" className="control-label">
                          <span style={{ color: "#ff0000" }}>*</span>
                          Forum Title
                        </label>
                        <input
                          id="Forum Name"
                          type="text"
                          className={`form-control ${this.state.errors.name ? "error" : ""
                            }`}
                          name="name"
                          value={this.state.name}
                          onChange={this.handleFormChange}
                          placeholder="Type here"
                          ref={this.nameInputRef}
                        ></input>
                        {this.state.errors.name && (
                          <div className="errorMsg">
                            {this.state.errors.name}
                          </div>
                        )}
                      </div>
                      <br />
                      <hr className="mx-n3" />
                      <div className="form-group">
                        <label htmlFor="diaplay_name" className="control-label">
                          <span style={{ color: "#ff0000" }}>*</span>
                          Forum Diaplay Name
                        </label>
                        <input
                          ref={this.nameInputRef}
                          id="diaplay_name"
                          type="text"
                          className={`form-control ${this.state.errors.diaplay_name ? "error" : ""
                            }`}
                          name="diaplay_name"
                          value={this.state.diaplay_name}
                          onChange={this.handleFormChange}
                          placeholder="Type here"
                        ></input>
                        {this.state.errors.diaplay_name && (
                          <div className="errorMsg">
                            {this.state.errors.diaplay_name}
                          </div>
                        )}
                      </div>
                      <br />
                      <hr className="mx-n3" />

                      <div className="form-group">
                        <label htmlFor="college_name" className="control-label">
                          <span style={{ color: "#ff0000" }}>*</span>
                          College Name
                        </label>
                        <select
                          onChange={(e) => {
                            this.setState({
                              college_code:
                                e.target.selectedOptions[0].attributes.name
                                  .nodeValue,
                              college_name: e.target.selectedOptions[0].value,
                            });
                          }}
                          ref={this.nameInputRef}
                          id="college_name"
                          type="button"
                          className={`form-select ${this.state.errors.college_name ? "error" : ""
                            }`}
                          name="college_name"
                        >
                          <option value={null}>--Select College--</option>
                          {this.state.CollegeData.map((e, key) => {
                            return (
                              <option
                                style={{ textAlign: "left" }}
                                key={key}
                                value={e.college_name}
                                name={e.college_code}
                              >
                                {e.college_name}
                              </option>
                            );
                          })}
                        </select>
                        <div className="errorMsg">
                          {this.state.errors.college_name}
                        </div>
                      </div>
                      <br />
                      <hr className="mx-n3" />

                      <div className="form-group">
                        <label htmlFor="college_code" className="control-label">
                          College Code
                        </label>
                        <input
                          id="college_code"
                          type="text"
                          className="form-control"
                          name="college_code"
                          value={this.state.college_code}
                          onChange={this.handleFormChange}
                          readOnly
                        ></input>
                      </div>

                      <br />
                      <hr className="mx-n3" />

                      <div className="form-group">
                        <label
                          htmlFor="forum_full_description"
                          className="control-label"
                        >
                          <span style={{ color: "#ff0000" }}>*</span>
                          Forum Description
                        </label>
                        <input
                          ref={this.nameInputRef}
                          id="forum_full_description"
                          type="text"
                          className={`form-control ${this.state.errors.forum_full_description
                            ? "error"
                            : ""
                            }`}
                          name="forum_full_description"
                          value={this.state.forum_full_description}
                          onChange={this.handleFormChange}
                          placeholder="Type here"
                        ></input>
                        <div className="errorMsg">
                          {this.state.errors.forum_full_description}
                        </div>
                      </div>
                      <br />
                      <hr className="mx-n3" />

                      <div className="form-group">
                        <label htmlFor="forum_type" className="control-label">
                          <span style={{ color: "#ff0000" }}>*</span>
                          Forum Type
                        </label>
                        <input
                          ref={this.nameInputRef}
                          id="forum_type"
                          type="text"
                          className={`form-control ${this.state.errors.forum_type ? "error" : ""
                            }`}
                          name="forum_type"
                          value={this.state.forum_type}
                          onChange={this.handleFormChange}
                          placeholder="Type here"
                        ></input>
                        {/*this.state.errors.forum_type && <div className="errorMsg">
                          {this.state.errors.forum_type}
                      </div>*/}
                      </div>
                      <br />
                      <hr className="mx-n3" />
                      <div className="form-group">
                        <label htmlFor="Is Published" className="control-label">
                          <span style={{ color: "#ff0000" }}>*</span>
                          Is Published
                        </label>
                        <select
                          id="Is Published"
                          className={`form-select ${this.state.errors.is_published ? "error" : ""
                            }`}
                          name="is_published"
                          value={this.state.is_published}
                          onChange={this.handleFormChange}
                          disabled={
                            this.state.status === false ? "disabled" : null
                          }
                        >
                          <option value="">--Choose--</option>
                          <option value="true">YES</option>
                          <option value="false">NO</option>
                        </select>
                        {this.state.errors.is_published && (
                          <div className="errorMsg">
                            {this.state.errors.is_published}
                          </div>
                        )}
                      </div>
                      <br />
                      {/* <hr className="mx-n3" />
                      <div className="form-group">
                        <label
                          htmlFor="forum_created_by"
                          className="control-label"
                        >
                          <span style={{ color: "#ff0000" }}>*</span> Forum
                          Created Person Name
                        </label>
                        <input
                          ref={this.nameInputRef}
                          id="forum_created_by"
                          type="text"
                          className={`form-control ${
                            this.state.errors.forum_created_by ? "error" : ""
                          }`}
                          name="forum_created_by"
                          value={this.state.forum_created_by}
                          onChange={this.handleFormChange}
                          placeholder="Type here"
                        ></input>
                        {this.state.errors.forum_created_by && (
                          <div className="errorMsg">
                            {this.state.errors.forum_created_by}
                          </div>
                        )}
                      </div>
                      <br />
                      <hr className="mx-n3" /> */}

                      <div className="textOnInputs">
                        <div className="col-md-12 mt-3">
                          <label htmlFor="image">
                            <span style={{ color: "#ff0000" }}>*</span>Forum
                            Image
                          </label>
                          <input
                            type="file"
                            accept="image/png, image/gif, image/jpeg"
                            id="image"
                            name="forum_images"
                            className="form-control-file"
                            onChange={this.uploadImageToS3}
                          />
                          {this.state.forum_images.length > 0
                            ? this.state.forum_images.map((img) => {
                              return (
                                <div
                                  className="card"
                                  style={{ margin: 10, width: 200 }}
                                >
                                  <img
                                    src={img.url}
                                    key={img.url}
                                    className="card-img-top"
                                    alt={img.name}
                                    width="100px"
                                    height="100px"
                                  />
                                  <button
                                    onClick={() => {
                                      this.removeImageURL(img.id);
                                    }}
                                    type="button"
                                    className="btn btn-danger"
                                  >
                                    Remove
                                  </button>
                                </div>

                                // <img
                                //   id="image"
                                //   src={item.url}
                                //   alt="No Image"
                                //   width="100px"
                                //   height="80px"
                                // />
                              );
                            })
                            : ""}
                          <div className="errorMsg">
                            {this.state.errors.forum_images}
                          </div>
                        </div>
                      </div>
                      <br />
                      <hr className="mx-n3" />

                      <div className="form-group">
                        <button
                          type="submit"
                          id="btnSubmitSignup"
                          className="btn btn-primary btn-lg btn-block mb-2 mt-4"
                          style={{ margin: "4px" }}
                        >
                          {this.state.loader ? <LoaderRounded /> : "Add"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    UserData: state.PersistReducer.UserData.UserData,
    Selected_collgege: state.PersistReducer.UserData.selected_college,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(AddnewForum);
